// Social proof - James success story
import FeedbackPage from '@/components/FeedbackPage'

export default function JamesTestimonialPage() {
  return (
    <FeedbackPage emoji="🌟" title="pages.onboarding.jamesTestimonial.title" />
  )
}
